/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import useStyles from '../../assets/styles/components/searchShops';

import { actionListdShops } from '../../store/reduces/ReducerListShops';

// import svg
import { ReactComponent as IconSearch } from '../../assets/images/svg/shops/icon_pesquisa.svg';

import { useSelectedStateCityContext } from '../../providers/use-selected-state-city';
import { useLoadingContext } from '../../providers/use-loading';
import { getStorege } from '../../helpers/db_storage';

const SearchShops = ({ children }: any) => {
  const classeStyle = useStyles();
  const navigate = useNavigate();
  const selectedStateCityContext = useSelectedStateCityContext();
  const dispatch = useDispatch();
  const { search: des_search }: any = useParams();

  const { noLoading } = useLoadingContext();

  const [search, setSearch] = useState<string>('');

  const handleToPage = (url: string): any => {
    return navigate(url);
  };

  const handleSearch = (): any => {
    const dataUserStorage = getStorege('@mais/delivery/user');

    if (selectedStateCityContext.data.dsCidade && children.id_category) {
      dispatch(
        actionListdShops.searchListdShops({
          nr_operacao: 20,
          idMarketplace: selectedStateCityContext.data.idMarketplace,
          idCategoria: children.id_category,
          dsBusca: search,
          dsCidade: selectedStateCityContext.data.dsCidade,
          idUsuario: dataUserStorage?.idUsuario
            ? dataUserStorage?.idUsuario
            : '0',
        }),
      );
    }
  };

  useEffect(() => {
    const listener = (event: any): any => {
      if (search && children.page !== 'shops') {
        if (
          event.code === 'Enter' ||
          event.code === 'NumpadEnter' ||
          event.keyCode == '13' ||
          event.keyCode == '13'
        ) {
          handleToPage(
            `list/shops/now/open/${window.btoa(children)}/${window.btoa(
              search,
            )}`,
          );
          event.preventDefault();
        }
      }
      if (search) {
        if (
          event.code === 'Enter' ||
          event.code === 'NumpadEnter' ||
          event.keyCode == '13' ||
          event.keyCode == '13'
        ) {
          handleSearch();
          event.preventDefault();
        }
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    noLoading(true);

    handleSearch();
  }, [search]);

  useEffect(() => {
    if (des_search) {
      setSearch(window.atob(des_search));
    }
  }, [des_search]);

  return (
    <Grid
      container
      item
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Grid
        container
        item
        justifyContent="flex-start"
        alignItems="center"
        textAlign="center"
      >
        <IconSearch className={classeStyle.iconSearch} />
        <input
          className={classeStyle.inputText}
          type="text"
          placeholder="Buscar estabelecimento ou seu produto favorito"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </Grid>
    </Grid>
  );
};
export default SearchShops;
